<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button" :to="{ path: '/connection/edit/' }"><i class="fa fa-plus"></i></router-link>
          </div>
          <h1>Connections</h1>

          <div class="row">
            <div class="col-xs-12">
              <h2>Kereső</h2>
            </div>
            <div class="col-xs-2">
              <inputbox id="name" @keydownEnter="searchClick" label="Megnevezés" id="name" name="name" v-model="search.name"></inputbox>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="gateway_id" label="Gateway" name="gateway_id" v-model="search.gateway_id" :options="gateways"></comboboxV2>
            </div>
            <div class="col-xs-3">
              <button class="button with-icon" style="margin-top: 24px" type="button" v-on:click="searchClick"><i class="fa fa-search"></i>Keresés</button>
            </div>
          </div>

          <div v-if="connections.length > 0" class="table-with-title">
            <h2>Connections</h2>
            <table class="list">
              <thead>
                <tr>
                  <th>Megnevezés</th>
                  <th>Gateway</th>
                  <th>IP</th>
                  <th>Port</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="connection in connections">
                  <td>{{connection.name}}</td>
                  <td>{{connection.gateway}}</td>
                  <td>{{connection.ip}}</td>
                  <td>{{connection.port}}</td>
                  <td class="buttons">
                    <router-link class="small-button" :to="{ path: '/connection/edit/', query: { connectionID: connection.element_id }}"><i class="fa fa-pencil-alt"></i></router-link>
                    <a class="small-button" href="javascript:void(0)" v-on:click="del(connection.element_id)"><i class="fa fa-trash-alt"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination v-if="connections.length > 0" showcombo="1" :limit="search.limit" :amount="search.amount" v-on:pageChanged="pageChanged" v-model="search.page"></pagination>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      search: {
        name: '',
        gateway_id: 0,
        page: 1,
        limit: 100,
        amount: 0
      },

      connections: [],
      gateways: [{
        label: '- összes -',
        value: 0
      }]
    }
  },

  watch: {
    '$route': 'routerChange'
  },

  created: function() {
    this.routerChange();
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('gateways/' + _this.$root.user.apikey + '/1', {
        data: {},
        method: 'POST',
        success: function(response) {
          response.gateways.map(function(gateway) {
            _this.gateways.push({
              label: gateway.name,
              value: gateway.element_id
            })
          });
        }
      });
    });
  },

  methods: {
    del: function(id) {
      var _this = this;

      swal({
        title: 'Törli az connection-t?',
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('connection/delete/' + _this.$root.user.apikey + '/' + id, {
            success: function(response) {
              _this.getItems();
            }
          });
        }
      });
    },

    routerChange: function() {
      if (Object.keys(this.$route.query).length != 0) {
        this.search = $.extend(this.search, JSON.parse(JSON.stringify(this.$route.query)));
      }

      this.getItems();
    },

    searchClick: function() {
      this.search.page = 1;
      this.$router.push({path: '/connections', query: this.search});
    },

    pageChanged: function(val) {
      this.search.page = val;
      this.$router.push({path: '/connections', query: this.search});
    },

    getItems: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('connections/' + _this.$root.user.apikey, {
          data: _this.search,
          method: 'POST',
          success: function(response) {
            _this.connections = response.connections;
            _this.search.amount = response.amount;
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// connections.vue?6d7ad0f3